export const ContactAPIURL = "https://10mkj9tn97.execute-api.ap-northeast-1.amazonaws.com/production/ContactToMail"
export const iOSApplicationURL = "https://apps.apple.com/jp/app/clubcloud/id1493415222"
export const AndroidApplicationURL = "https://play.google.com/store/apps/details?id=jp.club_cloud.clubcloud&hl=ja"
